export const getFileName = (documentName) => {
  const fileExtension = documentName.split('.')[1];
  switch (fileExtension) {
    case 'xlsx':
      return 'file_excel';
    case 'pdf':
      return 'file_pdf';
    default:
      return 'file_document';
  }
};

export const getFormattedDate = (generationDate) => {
  const date = new Date(generationDate);
  return date.getMonth() + 1 + '.' + date.getDate() + '.' + date.getFullYear();
};

export const removeExtension = (documentName) => {
  const extensionDotIndex = documentName.lastIndexOf('.');
  if (extensionDotIndex === -1) return documentName;
  return documentName.slice(0, extensionDotIndex);
};
